import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  viewboxHeight: 12,
  viewboxWidth: 12,
};

export default ({
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => (
  <SVGLoader
    viewboxHeight={viewboxHeight}
    viewboxWidth={viewboxWidth}
    {...rest}
  >
    <path d="M11.615 5.96a.12.12 0 0 0 .09.035.13.13 0 0 0 .09-.035.76.76 0 0 0 .205-.5v-3.9a.746.746 0 0 0-1.085-.67l-2 1a.75.75 0 0 0-.415.67v1.88a.7.7 0 0 0 .035.225.12.12 0 0 0 .12.085h.095a4 4 0 0 1 2.865 1.21M7.9 4.84a.12.12 0 0 0 .1-.12V.75A.75.75 0 0 0 7.25 0H.75A.75.75 0 0 0 0 .75v5.5A.75.75 0 0 0 .75 7h4.325a.13.13 0 0 0 .115-.07A4 4 0 0 1 7.9 4.84" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 8.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0m-2.077 1.383h-.808V7.5h.813q.264 0 .483.09a1.1 1.1 0 0 1 .63.653q.088.23.088.512v.125q0 .28-.088.511-.087.232-.248.398a1.1 1.1 0 0 1-.382.255q-.22.09-.488.089m0-.423h-.266V7.925h.271q.158 0 .279.054.12.053.204.157t.125.26q.043.153.043.355v.129q0 .264-.075.45a.6.6 0 0 1-.221.284.64.64 0 0 1-.36.096m-1.82-.715h-1.06v1.138H6.5V7.5h.542v1.072h1.06V7.5h.54v2.633h-.54z"
    />
  </SVGLoader>
);
